import { useEffect } from 'react';
import useLabelingStore from '../store/useDetectionStore';

const CURSORS = {
  draw: 'crosshair',
  polygon: 'crosshair',
  pan: 'grab',
  select: 'default',
};

/**
 * Applies the active tool to the canvas: selection mode, cursor, and the
 * drag-to-pan handlers for the pan tool.
 *
 * Handlers are added and removed by reference — a bare `canvas.off('mouse:down')`
 * here used to strip the box/polygon drawing handlers registered by the other
 * hooks, which is why drawing occasionally went dead after a mode change.
 */
const useModeHandlers = (canvas, mode, polygonObj, setIsDrawingPolygon, setPolygonPoints, setPolygonObj) => {
  useEffect(() => {
    if (!canvas) return undefined;

    canvas.selection = mode === 'select';
    canvas.defaultCursor = CURSORS[mode] || 'default';
    canvas.hoverCursor = mode === 'select' ? 'move' : canvas.defaultCursor;

    if (mode !== 'polygon') {
      setIsDrawingPolygon(false);
      setPolygonPoints([]);
      if (polygonObj) {
        canvas.remove(polygonObj);
        setPolygonObj(null);
      }
    }

    if (mode !== 'pan') return undefined;

    const onMouseDown = () => {
      canvas.defaultCursor = 'grabbing';
      canvas.selection = false;
    };

    const onMouseMove = (o) => {
      if (o.e.buttons !== 1) return;
      // through the store so the pan is clamped like every other view change
      useLabelingStore.getState().panBy(o.e.movementX, o.e.movementY);
    };

    const onMouseUp = () => {
      canvas.defaultCursor = 'grab';
    };

    canvas.on('mouse:down', onMouseDown);
    canvas.on('mouse:move', onMouseMove);
    canvas.on('mouse:up', onMouseUp);

    return () => {
      canvas.off('mouse:down', onMouseDown);
      canvas.off('mouse:move', onMouseMove);
      canvas.off('mouse:up', onMouseUp);
    };
  }, [canvas, mode, polygonObj, setIsDrawingPolygon, setPolygonPoints, setPolygonObj]);
};

export default useModeHandlers;
